export default class ErrorMessageController {
  constructor($attrs) {
    'ngInject'
    this._$attrs = $attrs
  }

  $postLink() {
    this._$attrs.$addClass('vd-input-error-message-section')
  }
}
